import { TYPE_DATE } from "constants/enums";
import { format, lastDayOfMonth, startOfMonth } from "date-fns";
import { useDispatch } from "react-redux";

export const getTagTypeDashoard = tag =>
  tag === "Sped Contribuições"
    ? "contribuicoes"
    : tag === "Sped Fiscal"
    ? "fiscal"
    : "xml";

export const getDatesMonths = (vendasDateStart, vendasDateEnd) => {
  const [dateStart, dateEnd] = [
    new Date(vendasDateStart),
    new Date(vendasDateEnd),
  ];

  const current = new Date();

  if (format(current, "MM") === format(dateEnd, "MM"))
    return [dateStart, current];

  return [dateStart, dateEnd];
};

export const useChangeDateMonthlyAndDaily = () => {
  const dispatch = useDispatch();

  const sendNewDateToRedux = (value, periodMonthly, funcDispatch) => {
    const isValidForPeriod =
      (periodMonthly === TYPE_DATE.DAILY && value?.length === 2) ||
      (periodMonthly === TYPE_DATE.MONTHLY && value?.length >= 1);

    if (!isValidForPeriod) {
      return;
    }

    const dateInit = startOfMonth(value[0]);
    const dateEnd = lastDayOfMonth(value[0]);

    if (Number.isNaN(dateInit.getTime()) || Number.isNaN(dateEnd.getTime())) {
      return;
    }

    dispatch(
      funcDispatch({
        dateInit,
        dateEnd,
        dateRange:
          periodMonthly === TYPE_DATE.DAILY ? value : [dateInit, dateEnd],
        periodMonthly,
      }),
    );
  };

  return { sendNewDateToRedux };
};
